// /add-student?code=<CODE>&via=<LINK|QR|CODE>: Add student & delivery address (APP 004), behind
// 003's route and hand-off (specs/003-school-join-link/contracts/join-handoff.md).
import { AddStudentScreen } from "@/profile/addStudent/AddStudentScreen";

export default function AddStudent() {
  return <AddStudentScreen />;
}
